/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';

import * as selectNetworks from '../config/selectNetworks';
import * as selectMemberPlan from '../memberPlan/selectMemberPlan';

export const fetchProviderCostParams = createSelector(
  [selectNetworks.currentSlug, selectMemberPlan.planAmounts],
  (currentSlug, planAmounts) => {
    const {
      individualDeductible,
      individualDeductibleAccumulation,
      individualOutOfPocketMax,
      individualOutOfPocketMaxAccumulation,
      familyDeductible,
      familyDeductibleAccumulation,
      familyOutOfPocketMax,
      familyOutOfPocketMaxAccumulation,
    } = planAmounts || {};
    return {
      networkSlug: currentSlug,
      individualDeductible,
      individualDeductibleAccumulation,
      individualOutOfPocketMax,
      individualOutOfPocketMaxAccumulation,
      familyDeductible,
      familyDeductibleAccumulation,
      familyOutOfPocketMax,
      familyOutOfPocketMaxAccumulation,
    };
  }
);
